export const FEATURE_MAP = {
  connect: 'Connect',
  dmb: 'DigitalMapBook',
  yieldAnalysis: 'YieldAnalysis'
};
